import Axios from "axios";
import * as apiFactory from "./ApiFactory";
import { Quarantine } from "@/models/Quarantine";

import type { AxiosResponse } from "axios";
import type { QuarantineUpload } from "@/models/Quarantine";
import type { FileExistsResponse, FileExistsRequest } from "@/models/Upload";

export async function getAll(clientName: string, brand: string, caseReference: string): Promise<Quarantine[]> {
  const client = await apiFactory.WithBearer();
  return await client.getWithPollingSignal<Quarantine[]>(["api/quarantine", clientName, brand, caseReference]);
}

export async function save(
  clientName: string,
  brand: string,
  caseReference: string,
  item: QuarantineUpload,
  fileName: string,
  data: Blob,
): Promise<void> {
  const client = await apiFactory.WithBearer();

  const location: string = await client.post<QuarantineUpload, string>(
    ["api/quarantine", clientName, brand, caseReference],
    item,
  );
  try {
    const readFile = new Promise<ArrayBuffer>((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = function () {
        resolve(reader.result as ArrayBuffer);
      };
      reader.onerror = function (error) {
        reject(error);
      };
      reader.readAsArrayBuffer(data || new Blob());
    });

    const arrayBuffer = await readFile;
    // Put to the URI returned
    const axiosResponse: AxiosResponse = await Axios.create().put(location, arrayBuffer, {
      headers: {
        "x-ms-blob-type": "BlockBlob",
        "content-type": "application/octet-stream",
      },
    });

    if (axiosResponse.status !== 201) {
      throw "Uri did not accept the put request";
    }
    // Notify the API that our upload has completed
    await client.put(["api/quarantine/ingress", clientName, brand, caseReference, item.fileReference]);
  } catch (ex) {
    await client.delete(["api/quarantine", clientName, brand, caseReference, item.fileReference]);
    throw ex;
  }
}

export async function exists(
  clientName: string,
  brand: string,
  caseReference: string,
  request: { fileName: string },
): Promise<FileExistsResponse> {
  const client = await apiFactory.WithBearer();
  return await client.post<FileExistsRequest, FileExistsResponse>(
    ["api/quarantine/exists", clientName, brand, caseReference],
    request,
  );
}
